"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const world_1 = require("../icons/world");
exports.default = world_1.World;
